import type { FlightCalendar } from 'common/packageCache';
import moment from 'moment';

function renderLastSeenAtCell(text: string, record: FlightCalendar): string {
  return record.updateTime ? moment(record.updateTime).format('YYYY-MM-DD') : '';
}

export default renderLastSeenAtCell;
